<template>
  <div class="layout">
    <div class="layout-body">
      <layout-sider></layout-sider>
      <div class="layout-main">
        <div class="layout-header">
          <page-path></page-path>
          <el-button type="text" @click="handleLogout">退出登录</el-button>
        </div>
        <div class="layout-content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutSider from './components/layout-sider/layout-sider'
import PagePath from './components/page-path/page-path'
import { logout } from '@/api'

export default {
  name: 'layout',
  components: {
    LayoutSider,
    PagePath,
  },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleLogout() {
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        logout().then(res => {
          this.$router.push('/login')
          sessionStorage.removeItem('userData')
        })
      })
    },
  },
}
</script>

<style scoped lang="less">
.layout {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: #efefef;
  .layout-body {
    display: flex;
    flex-grow: 1;
    min-height: 0;
    .layout-main {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      min-width: 0;
      .layout-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;
      }
      .layout-content {
        overflow: auto;
        flex-grow: 1;
        padding: 14px;
        margin: 0px 14px 14px;
        border-radius: 6px;
        overflow: auto;
        border: 1px solid #eee;
        box-shadow: 5px 5px 10px 5px #dfdfdf;
        background-color: #fff;
      }
    }
  }
}
</style>
